import { ChevronLeft, ChevronRight, Presentation, RotateCcw, SlidersHorizontal } from "lucide-react";
import { SECTIONS, useDeck } from "../../lib/deck-context";
import { SaveButton } from "./SaveControls";

export const TopBar = ({ onPresent }) => {
  const { idx, setPanelOpen, modified, reset, go } = useDeck();
  return (
    <header data-testid="top-bar" className="sticky top-0 z-30 bg-paper/85 backdrop-blur-xl border-b border-line">
      <div className="flex items-center gap-4 px-6 sm:px-10 lg:px-16 h-16">
        <div className="lg:hidden font-mono text-[11px] tracking-[0.35em] text-arq">ARQITEK</div>
        <select
          data-testid="mobile-section-select"
          className="lg:hidden ml-2 text-sm bg-transparent border border-line rounded-full px-3 py-1.5 max-w-[150px]"
          value={idx}
          onChange={(e) => go(Number(e.target.value))}
        >
          {SECTIONS.map((s, i) => <option key={s.id} value={i}>{s.num} {s.label}</option>)}
        </select>
        <div className="hidden lg:flex items-center gap-3 text-sm text-steel">
          <span className="font-mono text-xs text-arq">{SECTIONS[idx].num}</span>
          <span className="text-ink">{SECTIONS[idx].label}</span>
        </div>
        <div className="ml-auto flex items-center gap-2">
          <SaveButton />
          {modified && (
            <button data-testid="topbar-reset-btn" onClick={reset} className="hidden sm:flex items-center gap-1.5 rounded-full border border-arq/40 bg-arq-soft px-3.5 py-1.5 text-xs text-arq hover:bg-arq/10 transition-colors">
              <RotateCcw size={13} /> Unsaved changes · Undo
            </button>
          )}
          <button data-testid="topbar-assumptions-btn" onClick={() => setPanelOpen(true)} className="flex items-center gap-2 rounded-full border border-line bg-white px-4 py-1.5 text-sm text-ink hover:border-arq/50 transition-colors">
            <SlidersHorizontal size={14} /> <span className="hidden sm:inline">Assumptions</span>
          </button>
          <button data-testid="topbar-present-btn" onClick={onPresent} className="lg:hidden flex items-center gap-2 rounded-full bg-arq px-3 py-1.5 text-sm text-white">
            <Presentation size={14} />
          </button>
        </div>
      </div>
    </header>
  );
};

export const Pager = () => {
  const { idx, prev, next } = useDeck();
  return (
    <div className="px-6 sm:px-10 lg:px-16 pb-16 max-w-[1440px] mx-auto">
      <div className="flex items-center justify-between border-t border-line pt-8">
        <button data-testid="pager-prev-btn" disabled={idx === 0} onClick={prev} className="group flex items-center gap-3 text-sm text-char disabled:opacity-30">
          <ChevronLeft size={18} className="transition-transform group-hover:-translate-x-0.5" />
          {idx > 0 && <span><span className="font-mono text-xs text-steel mr-2">{SECTIONS[idx - 1].num}</span>{SECTIONS[idx - 1].label}</span>}
        </button>
        <button data-testid="pager-next-btn" disabled={idx === SECTIONS.length - 1} onClick={next} className="group flex items-center gap-3 text-sm text-ink disabled:opacity-30">
          {idx < SECTIONS.length - 1 && <span><span className="font-mono text-xs text-arq mr-2">{SECTIONS[idx + 1].num}</span>{SECTIONS[idx + 1].label}</span>}
          <ChevronRight size={18} className="transition-transform group-hover:translate-x-0.5" />
        </button>
      </div>
    </div>
  );
};
